import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HelpCenter from './HelpCenter';

export default function PublicHelpCenter() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const articleId = useMemo(() => searchParams.get('article') || null, [searchParams]);

  return (
    <HelpCenter
      initialArticleId={articleId}
      activeView="help"
      onClose={() => navigate('/')}
    />
  );
}
